module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "overflow-x": "hidden",
      "overflow-y": "scroll",
      "height": "100vh"
    }
  }, [_c('div', {
    staticClass: "header row middle-xs center-xs"
  }, [_c('div', {
    staticClass: "col-xs-2"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-xs-8 row bottom-xs center-xs header-text"
  }, [_c('span', {
    staticClass: "logo-text"
  }, [_vm._v(_vm._s(_vm.author_name) + " is a")]), _vm._v(" "), _c('img', {
    staticClass: "logo",
    staticStyle: {
      "vertical-align": "bottom"
    },
    attrs: {
      "src": "https://s3-us-west-1.amazonaws.com/parlay-staging-files/Logo.svg",
      "alt": ""
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "logo-text"
  }, [_vm._v("Trailblazer!")])]), _vm._v(" "), _c('div', {
    staticClass: "footer col-xs-2"
  }, [_c('span', [_vm._v("Want to try Parlay in your classroom?")]), _c('br'), _vm._v(" "), _c('button', {
    staticStyle: {
      "margin-top": "10px"
    },
    on: {
      "click": _vm.toParlaySite
    }
  }, [_vm._v("\n        GET STARTED\n      ")])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.loading_page),
      expression: "!loading_page"
    }],
    staticClass: "sub-header row center-xs middle-xs"
  }, [_c('span', [_vm._v("Check out this Chord Diagram from our class "), _c('br'), _vm._v("\n      discussion\n      "), _c('span', [_c('strong', [_vm._v("\"" + _vm._s(_vm.rt_name) + "\"")])])])]), _vm._v(" "), (_vm.loading_chord) ? _c('div', {
    staticClass: "row center-xs"
  }, [_c('pl-spinner', {
    staticClass: "x4",
    staticStyle: {
      "margin-top": "15%"
    }
  })], 1) : _c('chord-diagram', {
    staticClass: "chord row center-xs",
    attrs: {
      "summary": _vm.summary
    },
    on: {
      "showEmptyMessage": function($event) {
        _vm.show_empty_message = true
      }
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-52559185!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/components/dataVisualization/d3js/chordDiagramPublic.vue
// module id = 1923
// module chunks = 61